import { Button } from '../../actions/button/Button'
import { useOptionalShowChangesButtonContext } from '../../forms/context/showChangesButtonContext'
import { useTranslate } from '../../hooks'

type Props = {
  onClick: (show: boolean) => void
  isShowingChanges: boolean
}

export const FormikChangesButton = ({ isShowingChanges, onClick }: Props) => {
  const { shouldBeVisible } = useOptionalShowChangesButtonContext() ?? {}
  const translate = useTranslate()

  return shouldBeVisible ? (
    <Button
      aria-pressed={isShowingChanges}
      onClick={() => onClick(!isShowingChanges)}
      variant={isShowingChanges ? 'secondary' : 'discreet'}
      startIcon={isShowingChanges ? 'CheckCircle' : 'Circle'}
    >
      {translate('form.showOnlyChanges')}
    </Button>
  ) : null
}
